import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const CustomBillingContext = createContext(null);

type Props = {
  children: ReactElement;
};

const CustomBillingProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("account/subscriptions/custom", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <CustomBillingContext.Provider value={contextValue}>
      {children}
    </CustomBillingContext.Provider>
  );
};

export default CustomBillingProvider;
